// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Professional Loader Styles
 * Modern, professional loading indicator for the AFF Portal
 * Matches the application's design system and aesthetic
 */

.professional-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 120px;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

/* Default Variant - Full featured with background */
.loader-default {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Minimal Variant - Clean and simple */
.loader-minimal {
  background: transparent;
  padding: 16px;
}

/* Card Variant - For card-like containers */
.loader-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* Inline Variant - For inline usage */
.loader-inline {
  min-height: auto;
  padding: 8px;
  background: transparent;
  box-shadow: none;
  border: none;
}

/* Overlay Variant - For full screen overlays */
.loader-overlay {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  min-height: 160px;
  min-width: 200px;
}

.loader-overlay-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Spinner Animation */
.loader-spinner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-ring {
  position: absolute;
  border: 3px solid transparent;
  border-top: 3px solid #0D3B66;
  border-radius: 50%;
  animation: professionalSpin 1.4s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;
}

.spinner-ring:nth-child(1) {
  animation-delay: -0.45s;
  border-top-color: #0D3B66;
}

.spinner-ring:nth-child(2) {
  animation-delay: -0.3s;
  border-top-color: #FDBA74;
}

.spinner-ring:nth-child(3) {
  animation-delay: -0.15s;
  border-top-color: #f093fb;
}

/* Message Styling */
.loader-message {
  font-size: 14px;
  font-weight: 500;
  color: #4a5568;
  text-align: center;
  margin-top: 4px;
  letter-spacing: 0.025em;
  line-height: 1.4;
}

/* Size Variations */
.loader-small .spinner-ring {
  width: 20px;
  height: 20px;
  border-width: 2px;
}

.loader-small .loader-message {
  font-size: 12px;
}

.loader-medium .spinner-ring {
  width: 32px;
  height: 32px;
  border-width: 3px;
}

.loader-large .spinner-ring {
  width: 48px;
  height: 48px;
  border-width: 4px;
}

.loader-large .loader-message {
  font-size: 16px;
  font-weight: 600;
}

.loader-xlarge .spinner-ring {
  width: 64px;
  height: 64px;
  border-width: 5px;
}

.loader-xlarge .loader-message {
  font-size: 18px;
  font-weight: 600;
}

/* Professional Spin Animation */
@keyframes professionalSpin {
  0% {
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }

  50% {
    transform: rotate(180deg) scale(1.1);
    opacity: 0.8;
  }

  100% {
    transform: rotate(360deg) scale(1);
    opacity: 1;
  }
}

/* Hover Effects for Interactive Elements */
.professional-loader:hover .spinner-ring {
  animation-duration: 1.2s;
}

/* Responsive Design */
@media (max-width: 768px) {

  .loader-default,
  .loader-card {
    padding: 24px;
    border-radius: 12px;
  }

  .loader-overlay {
    margin: 20px;
    min-width: calc(100vw - 40px);
    max-width: 300px;
  }

  .loader-message {
    font-size: 13px;
  }

  .loader-large .spinner-ring {
    width: 40px;
    height: 40px;
  }

  .loader-xlarge .spinner-ring {
    width: 56px;
    height: 56px;
  }
}

@media (max-width: 480px) {

  .loader-default,
  .loader-card {
    padding: 20px;
  }

  .loader-message {
    font-size: 12px;
  }
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  .loader-default {
    background: rgba(26, 32, 44, 0.95);
    border-color: rgba(255, 255, 255, 0.1);
  }

  .loader-card {
    background: linear-gradient(135deg, rgba(26, 32, 44, 0.9) 0%, rgba(26, 32, 44, 0.7) 100%);
    border-color: rgba(255, 255, 255, 0.2);
  }

  .loader-overlay {
    background: rgba(26, 32, 44, 0.98);
    border-color: rgba(255, 255, 255, 0.2);
  }

  .loader-message {
    color: #e2e8f0;
  }
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .spinner-ring {
    border-top-color: #000;
  }

  .loader-message {
    color: #000;
    font-weight: 600;
  }

  .loader-default,
  .loader-card {
    border: 2px solid #000;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .spinner-ring {
    animation: professionalSpinReduced 2s linear infinite;
  }

  @keyframes professionalSpinReduced {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}

/* Focus States for Accessibility */
.professional-loader:focus-within {
  outline: 2px solid #0D3B66;
  outline-offset: 2px;
}

/* Loading States for Different Contexts */
.loader-context-dashboard .loader-default {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-color: rgba(102, 126, 234, 0.2);
}

.loader-context-modal .loader-default {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.loader-context-form .loader-minimal {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  padding: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/ProfessionalLoader.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,oDAAoD;AACpD;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,+FAA+F;EAC/F,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,gFAAgF;AAClF;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE;IACE,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,kCAAkC;IAClC,UAAU;EACZ;AACF;;AAEA,2CAA2C;AAC3C;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;;EAEE;;IAEE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;EAEE;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kCAAkC;IAClC,sCAAsC;EACxC;;EAEA;IACE,yFAAyF;IACzF,sCAAsC;EACxC;;EAEA;IACE,kCAAkC;IAClC,sCAAsC;EACxC;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;EACxB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,qDAAqD;EACvD;;EAEA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,yBAAyB;IAC3B;EACF;AACF;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,8FAA8F;EAC9F,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf","sourcesContent":["/**\n * Professional Loader Styles\n * Modern, professional loading indicator for the AFF Portal\n * Matches the application's design system and aesthetic\n */\n\n.professional-loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  min-height: 120px;\n}\n\n.loader-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n/* Default Variant - Full featured with background */\n.loader-default {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Minimal Variant - Clean and simple */\n.loader-minimal {\n  background: transparent;\n  padding: 16px;\n}\n\n/* Card Variant - For card-like containers */\n.loader-card {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%);\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  backdrop-filter: blur(8px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n/* Inline Variant - For inline usage */\n.loader-inline {\n  min-height: auto;\n  padding: 8px;\n  background: transparent;\n  box-shadow: none;\n  border: none;\n}\n\n/* Overlay Variant - For full screen overlays */\n.loader-overlay {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 9999;\n  background: rgba(255, 255, 255, 0.98);\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  min-height: 160px;\n  min-width: 200px;\n}\n\n.loader-overlay-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(4px);\n  z-index: 9998;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Spinner Animation */\n.loader-spinner {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner-ring {\n  position: absolute;\n  border: 3px solid transparent;\n  border-top: 3px solid #0D3B66;\n  border-radius: 50%;\n  animation: professionalSpin 1.4s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;\n}\n\n.spinner-ring:nth-child(1) {\n  animation-delay: -0.45s;\n  border-top-color: #0D3B66;\n}\n\n.spinner-ring:nth-child(2) {\n  animation-delay: -0.3s;\n  border-top-color: #FDBA74;\n}\n\n.spinner-ring:nth-child(3) {\n  animation-delay: -0.15s;\n  border-top-color: #f093fb;\n}\n\n/* Message Styling */\n.loader-message {\n  font-size: 14px;\n  font-weight: 500;\n  color: #4a5568;\n  text-align: center;\n  margin-top: 4px;\n  letter-spacing: 0.025em;\n  line-height: 1.4;\n}\n\n/* Size Variations */\n.loader-small .spinner-ring {\n  width: 20px;\n  height: 20px;\n  border-width: 2px;\n}\n\n.loader-small .loader-message {\n  font-size: 12px;\n}\n\n.loader-medium .spinner-ring {\n  width: 32px;\n  height: 32px;\n  border-width: 3px;\n}\n\n.loader-large .spinner-ring {\n  width: 48px;\n  height: 48px;\n  border-width: 4px;\n}\n\n.loader-large .loader-message {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.loader-xlarge .spinner-ring {\n  width: 64px;\n  height: 64px;\n  border-width: 5px;\n}\n\n.loader-xlarge .loader-message {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n/* Professional Spin Animation */\n@keyframes professionalSpin {\n  0% {\n    transform: rotate(0deg) scale(1);\n    opacity: 1;\n  }\n\n  50% {\n    transform: rotate(180deg) scale(1.1);\n    opacity: 0.8;\n  }\n\n  100% {\n    transform: rotate(360deg) scale(1);\n    opacity: 1;\n  }\n}\n\n/* Hover Effects for Interactive Elements */\n.professional-loader:hover .spinner-ring {\n  animation-duration: 1.2s;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n\n  .loader-default,\n  .loader-card {\n    padding: 24px;\n    border-radius: 12px;\n  }\n\n  .loader-overlay {\n    margin: 20px;\n    min-width: calc(100vw - 40px);\n    max-width: 300px;\n  }\n\n  .loader-message {\n    font-size: 13px;\n  }\n\n  .loader-large .spinner-ring {\n    width: 40px;\n    height: 40px;\n  }\n\n  .loader-xlarge .spinner-ring {\n    width: 56px;\n    height: 56px;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .loader-default,\n  .loader-card {\n    padding: 20px;\n  }\n\n  .loader-message {\n    font-size: 12px;\n  }\n}\n\n/* Dark Mode Support */\n@media (prefers-color-scheme: dark) {\n  .loader-default {\n    background: rgba(26, 32, 44, 0.95);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .loader-card {\n    background: linear-gradient(135deg, rgba(26, 32, 44, 0.9) 0%, rgba(26, 32, 44, 0.7) 100%);\n    border-color: rgba(255, 255, 255, 0.2);\n  }\n\n  .loader-overlay {\n    background: rgba(26, 32, 44, 0.98);\n    border-color: rgba(255, 255, 255, 0.2);\n  }\n\n  .loader-message {\n    color: #e2e8f0;\n  }\n}\n\n/* High Contrast Mode */\n@media (prefers-contrast: high) {\n  .spinner-ring {\n    border-top-color: #000;\n  }\n\n  .loader-message {\n    color: #000;\n    font-weight: 600;\n  }\n\n  .loader-default,\n  .loader-card {\n    border: 2px solid #000;\n  }\n}\n\n/* Reduced Motion */\n@media (prefers-reduced-motion: reduce) {\n  .spinner-ring {\n    animation: professionalSpinReduced 2s linear infinite;\n  }\n\n  @keyframes professionalSpinReduced {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n}\n\n/* Focus States for Accessibility */\n.professional-loader:focus-within {\n  outline: 2px solid #0D3B66;\n  outline-offset: 2px;\n}\n\n/* Loading States for Different Contexts */\n.loader-context-dashboard .loader-default {\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n  border-color: rgba(102, 126, 234, 0.2);\n}\n\n.loader-context-modal .loader-default {\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.loader-context-form .loader-minimal {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 8px;\n  padding: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
